import React, {
  createContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { InputAdornment, TextField } from "@mui/material";
import { Moneda } from "../../../Helpers/Moneda";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { ModalDetalleFinanciamiento } from "./ModalDetalleFinanciamiento";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


export const Context = createContext(null);

export const PrestamoClientesDetalleFinanciamiento = () => {
  const location = useLocation();
  const { folio, cliente } = location.state;
  const history = useHistory();

  const [detalle, setDetalle] = useState([]);
  const [info, setInfo] = useState({
    folio: "",
    monto: 0,
    fechaPagare: ""
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [stateFinanciamiento, setStateFinanciamiento] = useState({
    open: false,
    folio: "",
    docto: -1,
  });
  const [tipoAmortizacion, setTipoAmortizacion] = useState("M");
  const [valorInsoluto, setValorInsoluto] = useState(0);




  const contextValue = useMemo(
    () => ({
      stateFinanciamiento,
      setStateFinanciamiento,
    }),
    [stateFinanciamiento, setStateFinanciamiento]
  );

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setInfo({
      ...info,
      [prop]: sinComas,
    });
  };

  const openModal = (docto) => {
    setStateFinanciamiento({
      ...stateFinanciamiento,
      open: true,
      docto,
    });
  };

  const EliminarRegistro = (item) => {
    Swal.fire({
      title: "Deseas eliminar el registro?",
      showDenyButton: true,
      showCancelButton: true,
      showConfirmButton: false,
      confirmButtonText: "Save",
      cancelButtonText: "Cancelar",
      denyButtonText: `Eliminar`,
    }).then((result) => {
      if (result.isDenied) {
        setLoader({ ...loader, mostrar: true });
        request
          .get(
            `PedidoFinanciamiento/Delete?folio=${item.folio}&docto=${Number(
              item.docto
            )}`
          )
          .then((result) => {
            setDetalle(result.detalle_financiamiento);
            setLoader({ ...loader, mostrar: false });
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
          });
      }
    });
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PrestamoClientes/ObtenerDetalle?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        if (result.info !== null) {
          const sumaImportes = result.detallefinanciamiento.reduce(
            (acc, item) => acc + (parseFloat(item.importefinanciar) || 0),
            0
          );

          const valorInsoluto =
            (parseFloat(result.info.importe) || 0) - sumaImportes;

          setInfo({
            folio: result.info.folio_prestamo,
            monto: result.info.importe,
            fechaPagare: result.info.fecha_pagare
          });
          // if (result.detallefinanciamiento !== null) {
          //   setDetalle(result.detallefinanciamiento);
          // }
          setValorInsoluto(valorInsoluto);
          setDetalle(result.detallefinanciamiento);
          document.getElementById("monto").value = FormatMoney(
            result.info.importe
          );
          setStateFinanciamiento({
            ...stateFinanciamiento,
            folio: result.info.folio_prestamo,
          });
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
      });
  }, [stateFinanciamiento.open]);


  const onGuardar = () => {
    if (
      folio === "" ||
      folio === undefined ||
      folio === null
    ) {
      Swal.fire({
        title: "PEDIDO DE MAQUINARIA",
        text: "Folio no valido",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      setLoader({ ...loader, mostrar: false });
      return
    }
    else if (
      info.monto === "" ||
      info.monto === undefined ||
      info.monto === null
    ) {
      Swal.fire({
        title: "PEDIDO DE MAQUINARIA",
        text: "Introduzca el monto",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      setLoader({ ...loader, mostrar: false });
      return
    }
    else if (
      info.fechaPagare === "" ||
      info.fechaPagare === undefined ||
      info.fechaPagare === null
    ) {
      Swal.fire({
        title: "PEDIDO DE MAQUINARIA",
        text: "Selecciona la fecha del pagare",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      setLoader({ ...loader, mostrar: false });
    }
    const post = {
      folio: folio,
      monto: info.monto,
      fecha_pagare: info.fechaPagare
    };
    request
      .post("PrestamoClientes/Guardar", post)
      .then(async (result) => {
        await Swal.fire("Clientes", result.mensaje, "success");
        setInfo({
          ...info,
          folio: result.info.folio_prestamo,
          monto: result.info.importe,
        });
        setDetalle(result.detallefinanciamiento);
        document.getElementById("monto").value = FormatMoney(
          result.info.importe
        );
      })
      .catch((error) => {
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onEnviarTimeLine = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio_solicitud: folio,
      folio_prestamo: info.folio,
      monto: info.monto,
      cliente: cliente,
    };
    request
      .post("PrestamoClientes/Crear_Timeline", post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });

        await Swal.fire("Clientes", "Solicitud Enviada a Revisión", "success");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  return (
    <PlantillaScreen
      titulo={cliente}
      className={"prestamo-clientes-detalle-financiamiento-plantilla"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="prestamo-clientes-info-container">
        <div className="prestamo-clientes-info-informacion">
          <div className="prestamo-clientes-info-informacion-titulo">
            Folio de solicitud:
          </div>
          <div>{folio}</div>
        </div>
        <div className="prestamo-clientes-info-informacion">
          <div className="prestamo-clientes-info-informacion-titulo">
            Folio de prestamo:
          </div>
          <div>{info.folio}</div>
        </div>
        <div className="prestamo-clientes-info-informacion">
          <div className="prestamo-clientes-info-informacion-titulo-monto">
            Monto:
          </div>
          <div>
            <TextField
              fullWidth
              id="monto"
              size="small"
              label="Monto"
              variant="outlined"
              type="text"
              // className="pr-5 cel-6"
              inputProps={{
                style: { textAlign: "right" },
              }}
              onChange={({ target }) => {
                ValOnlyNumber("monto", target.value, onChange, true, 10);
              }}
              onKeyUp={(input) => Moneda(input.target)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon size="small" />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>
        <div className="prestamo-clientes-info-informacion">
          <div className="prestamo-clientes-info-informacion-titulo-pagare">
            Fecha de pagare:
          </div>
          <div>
            <TextField
              fullWidth
              size="small"
              label="Fecha de Pagare"
              variant="outlined"
              className="cel-1-1"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarMonthIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
              type="date"
              onChange={({ target }) => {
                setInfo({ ...info, fechaPagare: target.value });
              }}
              value={info.fechaPagare}
              sx={{ width: 185 }}
            ></TextField>
          </div>
        </div>
        <div className="boton-guardar-prestamo-clientes-container">
          <button
            className="boton-guardar-prestamo-clientes"
            onClick={() => onGuardar()}
          >
            {" "}
            GUARDAR
          </button>
        </div>
      </div>
      {info.folio !== "" && info.folio !== null && info.folio !== undefined ? (
        <Context.Provider value={contextValue}>
          <div className="detalle-financiamiento-prestamo-clientes-main-container">
            <div className="boton-agregar-detalle-financiamiento-container">
              <button
                className="boton-agregar-detalle-financiamiento-prestamo-clientes"
                onClick={() => openModal(-1)}
                fullWidth
                variant="contained"
              >
                Agregar
              </button>
              <ModalDetalleFinanciamiento
                tipoAmortizacion={tipoAmortizacion}
                valorInsoluto={valorInsoluto}
              />
            </div>
            <div className="detalle-financiamiento-prestamo-clientes-tabla-container scroll">
              <table cellPadding={0} cellSpacing={0}>
                <thead>
                  <tr>
                    <th>DOCTO</th>
                    <th>VENCIMIENTO</th>
                    <th>IMPORTE A FINANCIAR</th>
                    <th>DIAS</th>
                    <th>TASA %</th>
                    <th>INTERÉS</th>
                    <th>TOTAL A PAGAR</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {detalle === undefined ||
                    detalle === null ||
                    detalle === 0 ? (
                    <>Sin Datos</>
                  ) : (
                    detalle.map((item, index) => (
                      <tr>
                        <td>{item.docto}</td>
                        <td>{item.svencimiento}</td>
                        <td>{FormatMoney(item.importefinanciar)}</td>
                        <td>{item.dias}</td>
                        <td>{FormatMoney(item.tasa)}</td>
                        <td>{FormatMoney(item.interes)}</td>
                        <td>{FormatMoney(item.totalpagar)}</td>
                        {tipoAmortizacion === "M" ? (
                          <td>
                            {/* Solo mostrar CreateIcon si es el último elemento */}
                            {index === detalle.length - 1 && (
                              <CreateIcon onClick={() => openModal(item.docto)} />
                            )}
                          </td>
                        ) : tipoAmortizacion === "T" ? (
                          <td></td>
                        ) : (
                          <td>
                            <CreateIcon onClick={() => openModal(item.docto)} />
                          </td>
                        )}
                        {tipoAmortizacion === "M" ? (
                          <td>
                            {/* Solo mostrar CreateIcon si es el último elemento */}
                            {index === detalle.length - 1 && (
                              <DeleteIcon
                                onClick={() => EliminarRegistro(item)}
                              />
                            )}
                          </td>
                        ) : tipoAmortizacion === "T" ? (
                          <td></td>
                        ) : (
                          <td>
                            <DeleteIcon onClick={() => EliminarRegistro(item)} />
                          </td>
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="prestamo-clientes-container-footer-buttons-container">
              <div
                className="prestamo-clientes-container-footer-boton-regresar "
                onClick={() =>
                  history.push("/Credito/PrestamoClientes")
                }
              >
                <ArrowBackIcon /> Regresar
              </div>

              <div
                className="prestamo-clientes-container-footer-boton-enviar"
                onClick={
                  () => onEnviarTimeLine()
                  //   history.push("/Credito/PrestamoClientes")
                }
              >
                Timeline <ArrowForwardIcon />
              </div>
            </div>
          </div>
        </Context.Provider>
      ) : (
        <div></div>
      )}
    </PlantillaScreen>
  );
};
